import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    SummaryCard,
    CardHeader,
    ContentBody,
    ContentRow,
    CardDemi,
    CardTotalDynamic,
    CardDynamicFont,
    AmountHeader,
    QtyLabel,
    SumQtyLabel,
    SummaryLabel,
} from './Summary.styled';
import AddPoTitle from 'src/common/components/summary/AddPoTitle';
import { POTitleLabel, POTitleValue } from './AddPoTitle/AddPoTitle.styled';
import { getPriceInNumberDataType } from 'src/pages/reportUsage/utils/dataModificaionUtil';
import { getCurrencySymbol, setCurrencyFormat, setCurrencyFormatWithoutSymbol } from 'src/utils/util';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
const Summary = (props) => {
    const {
        numberOfExtraItems = 0,
        numberOfSets = 0,
        width,
        height,
        borderRadius,
        background,
        boxShadow,
        marginTop,
        widthOnSmallDevice,
        mediumWidth,
        landScapeWidth,
        mbWidth,
        mbMargin,
        margin,
        deskFontFamily,
        mariginRight,
        marginRightTotal,
        mbHeaderFontSize,
        isFromReportPaymentScreen,
        handleSumTotal,
        poTitle,
        totalSum,
        displayPrice,
        handleSumQty,
        totalQuantity,
        isFromConsignment,
        sumAdjTotal,
        handleAdjSumTotal,
        isPaymentScreen,
        isEquityTemplate,
        fontSize,
        setFontSize,
        totalFontSize,
        isLegacyMobile,
        poSummary,
        isEMEA,
        reportPaymentGridData,
        itemsListView,
        isCondensedView,
        summaryLabelColor,
        marginBottomCartScreen,
        isEquityPage,
        marginLeft,
        isFromConsignmentAdd = false,
        instrumentItemFromKB,
        implantableItemFromKB
    } = props;
    const { t } = useTranslation(); 
    const totalAdjSum =
        isFromReportPaymentScreen && isFromConsignment && handleAdjSumTotal();
 
    return (
        <>
            <SummaryCard
                width={width}
                height={height}
                background={background}
                boxShadow={boxShadow}
                borderRadius={borderRadius}
                marginTop={marginTop}
                widthOnSmallDevice={widthOnSmallDevice}
                mediumWidth={mediumWidth}
                landScapeWidth={landScapeWidth}
                mbWidth={mbWidth}
                mbMargin={mbMargin}
                isCondensedView={isCondensedView}
            >
                <CardHeader
                    mbHeaderFontSize={mbHeaderFontSize}
                    isFromReportPaymentScreen={
                        isFromReportPaymentScreen && isFromConsignment
                    }
                    isCondensedView={isCondensedView}
                    marginLeft={'10px'}
                >
                    <SummaryLabel
                        fontSize={fontSize}
                        summaryLabelColor={summaryLabelColor}
                        marginLeft={marginLeft}
                        isFromReportPaymentScreen
                    >
                        {t('common.summaryText')}
                    </SummaryLabel>
                    {/* {isFromReportPaymentScreen && isFromConsignment && (
                        <div>Tissue Services</div>
                    )} */}
                    {isFromReportPaymentScreen && isFromConsignment && (
                        <>
                            <QtyLabel
                                isFromReportPaymentScreen
                                isLegacyMobile={isLegacyMobile}
                            >
                                {t('reportUsage.itemList.qty')}
                            </QtyLabel>
                            <AmountHeader>{`${t(
                                    'common.amount'
                                )} ${getCurrencySymbol(
                                    localStorage.getItem('currencyISOCode')
                                )}`}
                            </AmountHeader>
                        </>
                    )}
                </CardHeader>

                <ContentBody margin={margin}>
                    {isFromReportPaymentScreen && poTitle?.length > 0 && (
                        <AddPoTitle
                            reportPaymentGridData={reportPaymentGridData}
                            poTitle={poTitle}
                            isFromReportPaymentScreen={
                                isFromReportPaymentScreen
                            }
                            isPaymentScreen={isPaymentScreen}
                            totalQuantity={totalQuantity}
                            isFromConsignment={isFromConsignment}
                        />
                    )}
                    {(!isEquityPage || !isCondensedView) && (
                        <ContentRow
                            setFontSize={setFontSize}
                            color={summaryLabelColor}
                            marginBottomCartScreen={marginBottomCartScreen}
                        >
                            {isFromReportPaymentScreen ? (
                                <POTitleLabel></POTitleLabel>
                            ) : (
                                <div>
                                    {isEquityTemplate
                                        ? t('common.itemsLabel')
                                        : itemsListView || isFromConsignmentAdd
                                        ? t('common.implants')
                                        : t('common.setsPascalCaseLabel')}
                                </div>
                            )}
                            {isFromReportPaymentScreen &&
                            displayPrice &&
                            poTitle?.length <= 0 ? (
                                <POTitleLabel isPaymentScreen={isPaymentScreen}>
                                    <div
                                        style={{
                                            color:
                                                sumAdjTotal !== null &&
                                                sumAdjTotal !== undefined &&
                                                parseFloat(sumAdjTotal) !==
                                                    parseFloat(
                                                        handleSumTotal()
                                                    ) &&
                                                !Number.isNaN(sumAdjTotal)
                                                    ? '#E5047E'
                                                    : '',
                                            textDecoration:
                                                sumAdjTotal !== null &&
                                                sumAdjTotal !== undefined &&
                                                parseFloat(sumAdjTotal) !==
                                                    parseFloat(
                                                        handleSumTotal()
                                                    ) &&
                                                !Number.isNaN(sumAdjTotal)
                                                    ? 'line-through'
                                                    : '',
                                        }}
                                    > 
                                        {isFromReportPaymentScreen ? (getPriceInNumberDataType(
                                            handleSumTotal()
                                            ) > 0 &&
                                            (isFromConsignment 
                                                ? setCurrencyFormatWithoutSymbol(handleSumTotal())
                                                : setCurrencyFormat(handleSumTotal())
                                            )) : (getPriceInNumberDataType(
                                                handleSumTotal()
                                            ) > 0 &&
                                            setCurrencyFormat(
                                                    handleSumTotal()
                                        ))}
                                    </div>
                                    {getPriceInNumberDataType(sumAdjTotal) >=
                                        0 &&
                                        isFromConsignment &&
                                        !poSummary && (
                                            <div>
                                                
                                                {setCurrencyFormatWithoutSymbol(totalAdjSum)}
                                            </div>
                                        )}
                                </POTitleLabel>
                            ) : isFromConsignmentAdd ?   (
                                <CardDynamicFont
                                mariginRight={mariginRight}
                                    deskFontFamily={deskFontFamily}
                                    style={{
                                        fontSize: setFontSize,
                                        color: summaryLabelColor,
                                    }}
                                > 
                                    {implantableItemFromKB}
                                </CardDynamicFont>
                            ):
                            (
                               !isFromReportPaymentScreen && <CardDynamicFont
                                mariginRight={mariginRight}
                                    deskFontFamily={deskFontFamily}
                                    style={{
                                        fontSize: setFontSize,
                                        color: summaryLabelColor,
                                    }}
                                > 
                                    {numberOfSets}
                                </CardDynamicFont>
                            )}
                        </ContentRow>
                    )}
                    {!isFromReportPaymentScreen && (
                        <ContentRow
                            setFontSize={setFontSize}
                            color={summaryLabelColor}
                            marginBottomCartScreen={marginBottomCartScreen}
                        >
                            <div>
                                {isEquityTemplate
                                    ? t('common.feeLabel')
                                    : itemsListView || isFromConsignmentAdd
                                    ? t('common.instruments')
                                    : isCondensedView && isEquityPage
                                    ? 'Products'
                                    : t('common.extraItems')}
                            </div>
                          {isFromConsignmentAdd ?  <CardDynamicFont
                          mariginRight={mariginRight}
                                deskFontFamily={deskFontFamily}
                                style={{
                                    fontSize: setFontSize,
                                    color: summaryLabelColor,
                                }}
                            >
                                {instrumentItemFromKB}
                            </CardDynamicFont> :
                            <CardDynamicFont
                                deskFontFamily={deskFontFamily}
                                mariginRight={mariginRight}
                                style={{
                                    fontSize: setFontSize,
                                    color: summaryLabelColor,
                                }}
                            >
                                {numberOfExtraItems}
                            </CardDynamicFont>}
                        </ContentRow>
                    )}
                    <ContentRow
                        setFontSize={totalFontSize}
                        color={summaryLabelColor}
                    >
                        <CardDemi
                            isFromReportPaymentScreen={
                                isFromReportPaymentScreen && isFromConsignment
                            }
                            summaryLabelColor={summaryLabelColor}
                        >
                            {t('common.totalText')}
                        </CardDemi>

                        {/* {isFromReportPaymentScreen && !isFromConsignment && (
                            <div style={{ paddingLeft: '33px' }}>
                                {handleSumQty()}
                            </div>
                        )} */}
                        {isFromReportPaymentScreen && isFromConsignment && (
                            <SumQtyLabel
                                isPaymentScreen={isPaymentScreen}
                                isEMEA={isEMEA === 'US' ? true : false}
                            >
                                {handleSumQty()}
                            </SumQtyLabel>
                        )}

                        {!isFromReportPaymentScreen ? (
                            <CardTotalDynamic
                                summaryLabelColor={summaryLabelColor}
                                marginRightTotal={marginRightTotal}
                            >
                                {isFromConsignmentAdd ? implantableItemFromKB + instrumentItemFromKB :  numberOfSets + numberOfExtraItems}
                            </CardTotalDynamic>
                        ) : displayPrice ? (
                            <POTitleValue
                                isFromReportPaymentScreen={
                                    isFromReportPaymentScreen &&
                                    isFromConsignment
                                }
                            >
                                <div
                                    style={{
                                        color:
                                            sumAdjTotal !== null &&
                                            sumAdjTotal !== undefined &&
                                            parseFloat(sumAdjTotal) !==
                                                parseFloat(handleSumTotal()) &&
                                            !Number.isNaN(sumAdjTotal)
                                                ? '#E5047E'
                                                : '',
                                        textDecoration:
                                            sumAdjTotal !== null &&
                                            sumAdjTotal !== undefined &&
                                            parseFloat(sumAdjTotal) !==
                                                parseFloat(handleSumTotal()) &&
                                            !Number.isNaN(sumAdjTotal)
                                                ? 'line-through'
                                                : '',
                                        fontFamily: 'AvenirNextWorld Demi',
                                    }}
                                >
                                    {getPriceInNumberDataType(handleSumTotal())
                                        ? `${isFromConsignment 
                                              ? setCurrencyFormatWithoutSymbol(handleSumTotal())
                                              : setCurrencyFormat(handleSumTotal())
                                          }`
                                        : `${isFromConsignment
                                              ? setCurrencyFormatWithoutSymbol(0)
                                              : setCurrencyFormat(0)
                                          }`}
                                </div>

                                {isFromConsignment && (
                                    <div
                                        style={{
                                            color: '#140F4B',
                                            textAlign: 'right',
                                            fontSize: isFromReportPaymentScreen
                                                ? '16px'
                                                : '14px',
                                            fontFamily:
                                                isFromReportPaymentScreen
                                                    ? 'AvenirNextWorld Demi'
                                                    : 'AvenirNextWorld Regular',
                                            letterSpacing:
                                                isFromReportPaymentScreen
                                                    ? '-0.13px'
                                                    : '',
                                            opacity: isFromReportPaymentScreen
                                                ? '1'
                                                : '',
                                        }}
                                    >
                                        {sumAdjTotal !== null &&
                                        sumAdjTotal !== undefined &&
                                        parseFloat(sumAdjTotal) !==
                                            parseFloat(handleSumTotal()) &&
                                        !Number.isNaN(sumAdjTotal)
                                            ? setCurrencyFormatWithoutSymbol(totalAdjSum)
                                            : null}
                                    </div>
                                )}
                            </POTitleValue>
                        ) : null}
                    </ContentRow>
                </ContentBody>
            </SummaryCard>
        </>
    );
};
export default Summary;
